import { forwardRef, useEffect, useRef, useState } from 'react';
import { Tooltip, Typography, TypographyProps } from '@rossum/ui/material';

export const ExtensionText = forwardRef<
  HTMLParagraphElement,
  {
    primaryText: string;
    secondaryText: string;
    inTooltip?: boolean;
  } & TypographyProps
>(({ primaryText, secondaryText, inTooltip, sx, ...props }, ref) => (
  <Typography
    ref={ref}
    variant="body2"
    sx={{
      fontSize: 12,
      color: t => t.palette.text.secondary,
      span: {
        color: t => t.palette.text.primary,
      },
      ...sx,
    }}
    {...props}
  >
    {secondaryText} - <span>{primaryText}</span>
  </Typography>
));

type EventNameWithActionsProps = {
  secondaryText: string;
  primaryText: string;
};

export const ExtensionTextWithTooltip = ({
  secondaryText,
  primaryText,
}: EventNameWithActionsProps) => {
  const [tooltipDisabled, setTooltipDisabled] = useState(true);
  const textRef = useRef<HTMLParagraphElement | null>(null);

  useEffect(() => {
    const node = textRef.current;
    if (node && node.offsetWidth < node.scrollWidth) {
      setTooltipDisabled(false);
    }
  }, []);

  const TextWithoutTooltip = (
    <ExtensionText
      ref={textRef}
      primaryText={primaryText}
      secondaryText={secondaryText}
      textOverflow="ellipsis"
      overflow="hidden"
      whiteSpace="nowrap"
    />
  );

  return tooltipDisabled ? (
    TextWithoutTooltip
  ) : (
    <Tooltip
      title={
        <ExtensionText
          primaryText={primaryText}
          secondaryText={secondaryText}
          inTooltip
        />
      }
      placement="top"
      slotProps={{
        tooltip: {
          onClick: e => e.stopPropagation(),
        },
      }}
    >
      {TextWithoutTooltip}
    </Tooltip>
  );
};
